<template>
  <div>
    <van-nav-bar
      class="backBox"
      title="修改密码"
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="content_box">
      <div class="login_box">
        <van-form @submit="onSubmit">
          <van-field
            v-model="oldPassword"
            name="oldPassword"
            type="password"
            label="旧密码"
            placeholder="请输入当前密码"
            :rules="[{ required: true, message: '请填写当前密码' }]"
          >
          </van-field>
          <van-field
            v-model="newPassword"
            type="password"
            name="newPassword"
            label="新密码"
            placeholder="密码必须包含大小写字母和数字的组合，6-16位"
            :rules="[{ required: true, message: '请填写新密码' }]"
          >
          </van-field>
          <van-field
            v-model="confirmPassword"
            type="password"
            name="confirmPassword"
            label="确认密码"
            placeholder="请再次输入新密码"
            :rules="[{ required: true, message: '请填写新密码' }]"
          >
          </van-field>
          <div style="margin: 16px">
            <van-button
              class="operate_btn"
              round
              block
              type="info"
              native-type="submit"
              >修改密码</van-button
            >
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from '../../api/api'
import * as common from '../../api/common'
import * as utils from '../../api/utils'
import md5 from 'js-md5'

import { Toast } from 'vant'
export default {
  data () {
    return {
      oldPassword: '',
      newPassword: '',
      confirmPassword: ''

    }
  },
  mounted () {

  },
  computed: {

  },
  methods: {
    onSubmit (values) {
      const para = {
        old_pass: md5(values.oldPassword),
        new_pass: md5(values.newPassword)
      }
      api
        .axiosRequest(api.urlList.modifyPassword, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {
            Toast.success('修改成功')
            setTimeout(() => {
              this.onClickLeft()
            }, 1000)
          } else {
            utils.judgeBackMsg(res)
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },
    onClickLeft () {
      this.$router.go(-1)
    }

  }
}
</script>
<style scoped lang="scss">
.content_box {
  .login_box {
    // position: absolute;
    // height: 430px;
    // margin-left: 1rem;
    // margin-right: 1rem;
    margin-top: 1rem;
    display: flex;
    flex-flow: column;
    background-color: white;
    border-radius: 12px;
    // box-shadow: 0px 1px 10px 1px rgba(1, 1, 1, 0.1);
    .login_title {
      margin-top: 1.25rem;
      font-size: 1.125rem;
      font-weight: bold;
      color: black;

      text-align: center;
    }
    .login_img {
      width: 1rem;
      margin-left: 1rem;
      margin-right: 1rem;
      // height: 1rem;
    }
    .login_btn {
      font-size: 1.125rem;
      color: #fff;
      font-weight: bold;
    }
    .bind {
      margin: 0.9375rem auto auto auto;
      background-color: white;
    }
    .bind-wrap {
      text-align: center;
    }
    .bind-itme-img {
      width: 2.5rem;
      height: 2.5rem;
    }
    .bottom-hint {
      margin: 2.8125rem auto 1.5625rem;
      font-size: 0.75rem;
      color: #999;
    }
    .login_item {
      box-sizing: border-box;
      display: flex;
      flex-flow: row;
      align-items: center;
      height: 3.125rem;
      margin-left: 1.5625rem;
      margin-right: 1.5625rem;
      border-bottom: 1px solid #ececec;
    }

    .operate_btn {
      // height: 3.1875rem;
      // width: 100%;
      margin-top: 2.5rem;
      // line-height: 3.1875rem;
      // text-align: center;
      // color: #007dff;
      // font-size: 1rem;
      // background: #fff;
      // border: none;
    }
  }
}
</style>
